module.exports = __webpack_public_path__ + "static/media/3 Blue.d045d279.svg";